import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";

interface WarningEventValidationDialogProps {
	isDrafting?: boolean;
	disabledDraft?: boolean;
	open: boolean;
	onClose: () => void;
	onDraft: (params?: { isPreview?: boolean }) => void;
}

const WarningEventValidationDialog: React.FC<
	WarningEventValidationDialogProps
> = ({ isDrafting = false, disabledDraft = false, open, onClose, onDraft }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="xs"
			fullWidth
			scroll="paper"
		>
			<DialogTitle
				display="flex"
				sx={{
					p: 3,
					pr: 2,
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Stack direction="row" spacing={2}>
					<Iconify
						icon="eva:alert-triangle-fill"
						color="warning.main"
						width={24}
					/>
					<Typography fontWeight={700} variant="h6">
						Thông tin chưa đầy đủ
					</Typography>
				</Stack>
			</DialogTitle>
			<Box px={3}>
				<Typography variant="body2">
					Bạn chưa nhập đủ thông tin. Hãy kiểm tra lại và hoàn tất nhé!
				</Typography>
			</Box>
			<DialogActions>
				<LoadingButton
					loading={isDrafting}
					onClick={() => onDraft()}
					disabled={disabledDraft}
					variant="outlined"
					color="inherit"
					size="medium"
				>
					Lưu nháp
				</LoadingButton>
				<Button
					variant="contained"
					color="warning"
					size="medium"
					onClick={onClose}
				>
					Kiểm tra ngay
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default WarningEventValidationDialog;
